import { getApplicationName } from '@gral/config.js';
import { Switch } from '@components/Inputs';
import { IForm } from '@ts/ui-models';

const AllowEmailsForm = (props: IForm) => {
  const { values, onCallbackChange } = props;
  return (
    <Switch
      leftLabel={['Allow ', getApplicationName(), ' to send me emails']}
      checked={values.value.allowTSEmails ?? false}
      onChangeValue={onCallbackChange('value.allowTSEmails')}
      value="checkedTSEmails"
    />
  );
};

export default AllowEmailsForm;
